import React, {useState, useEffect} from "react";
import SignIn from "./SignIn";
import Router from "../../Components/Router";
import EmailVerification from "./EmailVerification";

import { CognitoHelper } from '../../Utilities/CognitoHelper';

export default function LoginPage() {
    const [user, setUser] = useState(null);
    const [busy, setBusy] = useState(true);

    useEffect(function() {
        const cognitoHelper = new CognitoHelper()

        cognitoHelper.getSession(function(session) {
            const user = cognitoHelper.getUser()

            if (session.isValid()) {
                user.emailVerified = true
            }

            setUser(user);

            setBusy(false);
        }, function(error) {
            setUser(null);

            setBusy(false);
        })
    }, [])

    return (
      <div style={{ display: busy ? "none" : "" }}>
          {!user ? (
              <SignIn />
          ) : user.emailVerified ? (
                <Router />
          ) : <EmailVerification/>}
        </div>
    );
}
